/* VOICE LEARNING BY ITSELF (her call, 2026-09-24 — "both a button and
 * automatic"; built 2026-10-06). Once a visit, when she opens a tool that
 * learns from her edits, the server is asked whether it is due. It decides
 * (api/_lib/voiceLearn.js autoDue): only with TEN new edits where her words
 * differ from Brill's, and at most once a week. Otherwise the ask is a free
 * database read and nothing is spent.
 *
 * Silent by design: what it learns lands in Me → Voice, marked as learned from
 * her edits, editable and removable like her own — the same place the button's
 * results go. A failure here never reaches her screen; the button still works.
 */
import { useEffect } from "react";
import { useSession } from "@clerk/clerk-react";

const asked = new Set();   // once a visit per tool — a reload is a new visit

export function useAutoLearn(toolId, active) {
  const { session } = useSession();
  useEffect(() => {
    if (!active || !session || !toolId || asked.has(toolId)) return;
    asked.add(toolId);
    (async () => {
      try {
        const token = await session.getToken();
        await fetch("/api/chat", {
          method: "POST",
          headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
          body: JSON.stringify({ mode: "learn_voice", moduleId: toolId, tool: toolId, action: "auto" }),
        });
      } catch { /* the button in Me → Voice still works */ }
    })();
  }, [toolId, active, session]);
}
